<template>
  <div class="content">
    <div class="image" :class="{ is_ipad: isIPad }">
      <img :src="imgPath" />
    </div>
  </div>
</template>

<script>
import app from '../constant/app_config.js'
export default {
  name: 'NotificationAtStartup',
  data: function() {
    return {
      isIPad: false
    }
  },
  computed: {
    imgPath: function() {
      return `${app.api.base}/splash`
    }
  },
  mounted: function() {
    const ua = window.navigator.userAgent
    if (ua.indexOf('iPhone') >= 0 && window.innerWidth < 375) {
      this.isIPad = true
    }
  }
}
</script>
<style scoped>
.content {
  color: white;
  background: #000000;
  height: 100%;
}

.content .image {
  height: auto;
  vertical-align: middle;
  width: 100%;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.content .image img {
  width: 100%;
  height: 100%;
  vertical-align: middle;
}

.image.is_ipad {
  width: 80%;
}
</style>
